// GTM owns the pixel and its consent policy. Do not load it independently.
// Wait for vendor readiness instead of queuing email across page transitions:
// identify includes the URL at execution time, which could otherwise be secret.
if (!window.dripshipperSegmetricsIdentityBound) {
  window.dripshipperSegmetricsIdentityBound = true
  let lastEmail = null

  const identify = () => {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    const email = document.querySelector("[data-segmetrics-email]")?.getAttribute("data-segmetrics-email")
    if (!email) { lastEmail = null; return }
    const url = new URL(window.location.href)
    if (url.hostname !== "app2.dripshipper.io" || url.hash) return
    if ([...url.searchParams.keys()].some(key => /^(?:token|access_token|refresh_token|id_token|reset_password_token|confirmation_token|unlock_token|authenticity_token|password|password_confirmation|secret|client_secret|email|code|hmac|handoff)$/i.test(key))) return
    if (url.searchParams.get("seg-pixel") === "disable") return
    if (/(?:^|;\s*)_seg_disabled=1(?:;|$)/.test(document.cookie)) return
    if (!window.SegMet || window.SegMet.State?.trackingDisabled) return
    if (window._segs?.account !== "a1exbd" || !window._segq?.push) return
    if (lastEmail === email) return

    try {
      window._segq.push(["identify", email])
      lastEmail = email
    } catch (_) {
      // Analytics must never prevent signup or navigation.
    }
  }

  document.addEventListener("turbo:load", identify)
  document.addEventListener("segtrk.ready", identify)
  document.addEventListener("turbo:before-cache", () => {
    document.querySelectorAll("[data-segmetrics-email]").forEach(node => node.remove())
  })
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", identify, { once: true })
  } else {
    identify()
  }
}
